export default __webpack_public_path__ + "static/media/7.28b04612.jpg";